import script from "./AiChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChat.vue?vue&type=script&setup=true&lang=js"

import "./AiChat.vue?vue&type=style&index=0&id=417cb2b9&scoped=true&lang=css"

import exportComponent from "D:\\Web\\LanceFacilUserNEW\\ClientAPPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-417cb2b9"]])

export default __exports__